export function assertBookableTripDestination<
  T extends {
    nights: number | null;
    index: string | null;
    locationSlug: string | null;
  },
>(
  lineItemDestination: T,
): asserts lineItemDestination is T & {
  nights: number;
  index: string;
  locationSlug: string;
} {
  if (
    lineItemDestination.nights === null ||
    lineItemDestination.index === null ||
    lineItemDestination.locationSlug === null
  ) {
    throw new Error("Line item must have location, nights and index defined");
  }
  if (lineItemDestination.nights < 0) {
    throw new Error("Line item nights must be non-negative");
  }
  if (lineItemDestination.index === "") {
    throw new Error("Line item index must not be an empty string");
  }
}
